import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { pick } from 'lodash';
import {
  ApiService,
  CountryListService,
  DialogService,
  InputDatastoreService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';
import { BaseWizardService } from '../base.wizard.service';
import { RadiusServerWizardStep } from './radius.server.step';

@Injectable()
export class RadiusConfigWizardService extends BaseWizardService {
  openNew: boolean;
  state: ActivatedRoute;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentParam: any;
  closeWizard: BehaviorSubject<boolean>;

  constructor(
    dataApiService: ApiService,
    state: ActivatedRoute,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    private readonly valuesExchange: ValuesExchangeProvider
  ) {
    super(dataApiService, inputDatastoreService, countryListService, dialogService);
    this.state = state;
    this.stepClass = RadiusServerWizardStep;
    this.openNew = false;
    this.closeWizard = new BehaviorSubject(false);
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  openWizard(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    wizardId: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    wizardConfig: any,
    defaultParamsById = {},
    onSuccess = () => {},
    onFail = () => {}
  ): void {
    super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
    if (this.editMode) {
      this._setOutputForEditMode(defaultParamsById);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  _setDefaultParams(step: any, targetOutput: any, defaultParamsById: any = {}): void {
    super._setDefaultParams(step, targetOutput, defaultParamsById);
  }

  setNextStep(): void {
    super.setNextStep();
  }

  _setPreviousStep(): void {
    super._setPreviousStep();
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFinish(): any {
    this.currentStep.onNext();
    this.dirtyFlag = false;
    const output = this._getFormatOutput();
    if (this.editMode) {
      this.method = 'put';
      this.dataUrl = this.dataUrl + '/' + this.defaultParamsById.id;
    }

    const responseProcessed = this._saveRequest(output, false);
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      if (!this.requestFailed) {
        this.valuesExchange.notifyListeners('radius_server_update', {
          value: 'update',
          cacheBreaker: Date.now()
        });
        this.successMessage = !this.editMode
          ? 'Radius server configuration has been successfully added'
          : 'Radius server configuration has been successfully updated';
      }
    });
    return responseProcessed;
  }

  showExitInsteadOfClose(): boolean {
    if (this.isFinishingStep() && (this.requestFailed || this.errorMessage)) {
      return true;
    }
    return false;
  }
}
